export const SET_LOGGED_USER = 'SET_LOGGED_USER';
